// extracted by mini-css-extract-plugin
module.exports = {"dialog":"tooltip_wrap__dialog--3B7gI","tooltip":"tooltip_wrap__tooltip--3znB6","tooltipInner":"tooltip_wrap__tooltipInner--3u1G_","tooltipLeft":"tooltip_wrap__tooltipLeft--3Qh8N"};